import React, { useState } from 'react';
import { ActionModal } from '../../../../components';
import { getAwsAuthentication } from '../services/kb';
import makeToast from '../../../../components/toaster';
import { AwsAuthModalProps } from '../kb.props';
import { AwsAuthModalConfig } from '../data/constants';

function AwsAuthModal({ open, isLoading, dispatcher, idToUpload, service }: AwsAuthModalProps) {
  const [keys, setKeys] = useState({
    accessKey: '',
    secretKey: '',
  });

  const handleClose = () => {
    dispatcher({ type: 'AWS_AUTH_MODAL', payload: false });
    dispatcher({ type: 'SET_LOADING', payload: false });
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setKeys((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleAuthentication = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (!keys.accessKey.trim() || !keys.secretKey.trim()) {
      makeToast('error', 'Both Access Key ID and Secret Access Key are required.');
      return;
    }
    dispatcher({ type: 'SET_LOADING', payload: true });
    const payload = {
      access_key: keys.accessKey.trim(),
      secret_key: keys.secretKey.trim(),
    };
    try {
      const res = await getAwsAuthentication(idToUpload, payload);
      if (res.status === 200) {
        dispatcher({ type: 'FOLDER_STRUCTURE_MODAL_OPEN', payload: true });
        dispatcher({ type: 'SET_SERVICE', payload: service });
        dispatcher({ type: 'FOLDER_ID', payload: idToUpload });
        makeToast('success', res?.data?.message || 'Authentication successful');
        handleClose();
      }
    } catch (error) {
      makeToast('error', 'Authentication Failed');
      handleClose();
    }
  };

  return (
    <ActionModal
      className="w-[490px]"
      open={open}
      modalTitle={<h3 className="text-base font-bold">{AwsAuthModalConfig.title}</h3>}
      modalDesc={AwsAuthModalConfig.description}
      modalLogo={AwsAuthModalConfig.modalLogo}
      resetData={handleClose}
      confirmButtonText={
        isLoading ? AwsAuthModalConfig.isLoadingText : AwsAuthModalConfig.confirmButtonText
      }
      cancelButtonText={AwsAuthModalConfig.cancelButtonText}
      saveData={handleAuthentication}
      disableSaveButton={isLoading}
    >
      <div>
        <form>
          <div className="mb-4">
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label htmlFor="aws-access-key" className="block text-sm font-medium text-gray-700">
              {AwsAuthModalConfig.defaultValues.accessKey}
            </label>
            <input
              id="aws-access-key"
              type="password"
              name="accessKey"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
              placeholder="Enter Access Key ID"
              value={keys.accessKey}
              onChange={handleChange}
              disabled={isLoading}
            />
          </div>
          <div className="">
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label htmlFor="aws-secret-key" className="block text-sm font-medium text-gray-700">
              {AwsAuthModalConfig.defaultValues.secretKey}
            </label>
            <input
              id="aws-secret-key"
              type="password"
              name="secretKey"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
              placeholder="Enter Secret Access Key"
              value={keys.secretKey}
              onChange={handleChange}
              disabled={isLoading}
            />
          </div>
        </form>
      </div>
    </ActionModal>
  );
}

export default AwsAuthModal;
